export default "__VITE_ASSET__C9jpmyn1__"